<template>
  <div v-if="showUI" class="flex justify-end mr-0 w-auto mt-4 overflow-hidden">
    <transition
      enter-active-class="transition-all transform duration-300 ease-out"
      leave-active-class="transition-all transform duration-300 ease-out"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div class="flex items-center" v-if="isBlockHovered && !showPlan">
        <div class="text-white bg-blue-dark rounded px-4 py-2 mr-4 ">
          Plan du MOOC
        </div>
      </div>
    </transition>
    <div 
      class="c-the-plan flex-shrink flex-grow-0 flex flex-col"
      :class="{ 'faa-fade-in': ready && show }" 
      >
      <div class="flex justify-end flex-shrink-0">
        <!-- Hide/Close Profil Icon -->
        <div
          class="left-0 bg-white-o7 rounded-full shadow-dark w-10 h-10 p-4 mr-4 cursor-pointer"
          v-if="showPlan"
          @click="close"
        >
          <img src="@/assets/images/close-icon.svg" />
        </div>
        <div
          class="c-the-plan-block bg-blue-dark text-white rounded-l-md shadow-dark px-6 cursor-pointer"
          :class="{
            shown: showPlan,
            'cursor-pointer': !showPlan,
          }"
          @click="showPlan ? (showDetails = !showDetails) : (showPlan = true)"
          @mouseover="isBlockHovered = true"
          @mouseleave="isBlockHovered = false"
        >
          <div class="flex justify-between items-center py-2">
            <div class="w-10 h-10 flex items-center">
              <img class="h-6" src="@/assets/images/plan.svg" @load="loaded">
              </div>

            <img
              v-if="showPlan"
              class="inline w-4"
              src="@/assets/images/arrow-down-white-icon.svg"
              :class="{
                'transform rotate-180': showDetails,
              }"
            />
          </div>
        </div>
      </div>

      <div class="w-64 ml-auto mr-4 flex-shrink flex flex-col overflow-hidden" v-if="showDetails && showPlan">
        <div
          v-for="(item, idx) in availablePlan"
          :key="idx"
          class="text-left bg-white rounded-md shadow-dark py-2 px-6 mt-2 text-sm  overflow-auto"
          :class="{ 'flex-shrink-0': (itemThatIsOpened !== item), 'flex-grow-0': (itemThatIsOpened === item)}"
        >
          <div
            class="flex justify-between cursor-pointer"
            @click="openItem(item)"
          >
            <div>
              {{ item.name }}
            </div>
            <img
              v-if="item.children.length > 0"
              class="inline w-4"
              src="@/assets/images/arrow-down-icon.svg"
              :class="{
                'transform rotate-180': isItemChildrenOpened(item),
              }"
            />
          </div>

          <div v-if="itemThatIsOpened === item">
            <div
              v-for="(childItem, idx) in item.children"
              :key="idx"
              class="ml-2 mt-2 cursor-pointer"
            >
              <div
                class="flex justify-between cursor-pointer"
                @click="
                  openChildItem(childItem)
                "
              >
                <div>
                  {{ childItem.name }}
                </div>
                <img
                  v-if="childItem.children"
                  class="inline w-4"
                  src="@/assets/images/arrow-down-icon.svg"
                  :class="{
                    'transform rotate-180': childItemThatIsOpened === childItem,
                  }"
                />
              </div>
              <div v-if="childItemThatIsOpened === childItem">
                <div
                  v-for="(subChildItem, idx) in childItem.children"
                  :key="idx"
                  class="text-left ml-2 mt-2"
                >
                  <div
                    class="flex justify-between cursor-pointer"
                    @click="
                      openChildItem(subChildItem)
                    "
                  >
                    <div>
                      {{ subChildItem.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    ready: false,
    show: false,
    showPlan: false,
    showDetails: false,
    itemThatIsOpened: null,
    childItemThatIsOpened: null,
    isBlockHovered: false,
    // Make a plan by map location/building
    plan: [
      {
        name: '',
        slug: 'map_first_login',
        slugs: ['map_first_login'],
        children: [],
      },
      {
        name: '',
        slug: 'expert_house',
        slugs: ['expert_house'],
        children: [],
      }, 
      {
        name: '',
        slug: 'oph',
        slugs: ['oph_ca', 'oph_dg', 'oph_dgl', 'oph_caleol', 'oph_daf'],
        children: [],
      }, 
      {
        name: '',
        slug: 'construction_site',
        slugs: ['construction_site'],
        children: [],
      },
      {
        name: '',
        slug: 'town_hall',
        slugs: ['town_hall'],
        children: [],
      },
    ]
  }),
  watch: {
    showPlan: {
      handler(show) {
        if (!show) {
          this.showDetails = false
          this.itemThatIsOpened = null
          this.childItemThatIsOpened = null
          this.$emit('closing')
        } else {
          this.showDetails = true
          this.$emit('opening')
        }
      },
      immediate: true,
    },
    showUI: {
      handler(show) {
        setTimeout(() => {
          this.show = show;
        }, 250);
      },
      immediate: true,
    },
    $route: {
      handler(to) {
        // todo improve
        // Update content when going to home page
        if (to.name == 'Home') {
          this.loaded()
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState('Auth', [ 'userInfo' ]),
    showUI() {
      return this.$route.meta && this.$route.meta.showUI;
    },
    availablePlan() {
      return this.plan.filter((item) => {
        return (item.name ? true : false)
      })
    },
  },

  methods: {
    openItem(item) {
      if (item.children.length <= 0)
        return

      if (this.itemThatIsOpened === item) {
        this.itemThatIsOpened = null
      } else {
        this.itemThatIsOpened = item
      }
    },
    openChildItem(childItem) {
      if (!childItem.children || childItem.children.length <= 0) {
        this.$router.push({
          name: 'Scenario',
          params: {
            id: childItem.scenarioId,
            nodeId: childItem.nodeId
          }
        })
        this.showPlan = false
        return
      }

      if (this.childItemThatIsOpened === childItem) {
        this.childItemThatIsOpened = null
      } else {
        this.childItemThatIsOpened = childItem
      }
    },
    isItemChildrenOpened(item) {
      return this.itemThatIsOpened === item;
    },
    close() {
      this.showPlan = false
    },
    async loaded() {
      this.ready = false

      // Load locations and scenarios data todo: check concurency with other similar request
      if (this.$store.state.Locations.list.length <= 0) {
        await this.$store.dispatch('Locations/getList')
      }
      if (this.$store.state.Scenarios.list.length <= 0) {
        await this.$store.dispatch('Scenarios/getList') //todo: get list by locations ?
      }
      if (this.$store.state.Scenarios.firstNodeCandidates.length <= 0) {
        await this.$store.dispatch('Scenarios/getFirstNodeCandidates') //todo: get list by locations ?
      }

      // Get scenarios completion state
      const scenarioCompletionState = await this.$store.dispatch('Logs/getByTypeSlug', {
        type_slug: 'scenario_end',
      })

      const completedScenariosById = scenarioCompletionState.reduce((dict, log) => {
        dict[log.data_key] = true

        return dict
      }, {})

      // Get location names
      const locationsBySlug = this.$store.state.Locations.list.reduce((dict, location) => {
        dict[location.slug] = location

        return dict
      }, {})

      const scenariosById = this.$store.state.Scenarios.list.reduce((dict, scenario) => {
        dict[scenario.id] = scenario

        return dict
      }, {})

      const firstNodeCandidatesByScenarioId = this.$store.state.Scenarios.firstNodeCandidates.reduce((dict, node) => {
        dict[node.scenario_id] = node
        
        return dict
      }, {})

      let stop = false

      for (var i = 0; i < this.plan.length; i++) {
        // Get location name
        this.plan[i].name = locationsBySlug[this.plan[i].slug].title
        
        // Get children
        this.plan[i].children = []

        for (var j = 0; j < this.plan[i].slugs.length; j++) {
          const slug = this.plan[i].slugs[j]

          if (!locationsBySlug[slug].scenarioLocations || locationsBySlug[slug].scenarioLocations.length <= 0)
            continue

          // Get main scenario for this location
          let scenarioLocation = locationsBySlug[slug].scenarioLocations.find((scenarioLocation) => {
            return (scenariosById[scenarioLocation.scenario_id].type.slug == 'scenario')
          })

          if (!scenarioLocation) {
            scenarioLocation = locationsBySlug[slug].scenarioLocations[0]
          }

          const mainScenario = scenariosById[scenarioLocation.scenario_id]

          if (!firstNodeCandidatesByScenarioId[mainScenario.id])
            continue

          let children = []

          for (var k = 0; k < firstNodeCandidatesByScenarioId[mainScenario.id].triggers.length; k++) {
            const trigger = firstNodeCandidatesByScenarioId[mainScenario.id].triggers[k]

            if (trigger.type.slug == 'scene_button') {
              children.push({
                name: trigger.name,
                scenarioId: mainScenario.id,
                nodeId: trigger.triggered_node_id,
              })
            }
          }

          // If no obvious children get the scenario details
          if (children.length <= 0) {
            if (!this.$store.state.Scenarios.items[mainScenario.id]) {
              await this.$store.dispatch('Scenarios/getByID', mainScenario.id)
            }

            const scenario = this.$store.state.Scenarios.items[mainScenario.id]

            // Get all scene titles by order of appearence
            const nodesById = scenario.nodes.reduce((dict, node) => {
              dict[node.id] = node

              return dict
            }, {})

            let node = nodesById[firstNodeCandidatesByScenarioId[mainScenario.id].id]
            let branch = []
            let count = 0

            while (node && count < scenario.nodes.length) {
              count += 1
              
              let nextNode = null

              if (node.type.slug == 'scene' && node.title && node.title.toLowerCase() != this.plan[i].name.toLowerCase()) {
                children.push({
                  name: node.title,
                  scenarioId: mainScenario.id,
                  nodeId: node.id,
                })
              }

              if (node.triggers.length > 0) {
                // Find next node
                let nextTrigger = node.triggers.find((trigger) => {
                  return (trigger.triggerType.slug == 'continue')
                })

                if (!nextTrigger) {
                  nextTrigger = node.triggers[0]

                  for (var l = 1; l < node.triggers.length; l++) {
                    branch.push(node.triggers[l])
                  }
                }

                nextNode = nodesById[nextTrigger.triggered_node_id]
              }

              if (!nextNode && branch.length > 0) {
                const trigger = branch.shift()

                nextNode = nodesById[trigger.triggered_node_id]
              }

              node = nextNode
            }
          }

          if (this.plan[i].slugs.length > 1) {
            // Add a new children and his children
            this.plan[i].children.push({
              name: mainScenario.name,
              children,
            })
          } else {
            // Add children
            this.plan[i].children = children
          }

          // Stop here if the main scenarios is not completed, to avoid display unavailable scenarios
          if (!this.userInfo.experienced && !completedScenariosById[mainScenario.id]) {
            stop = true
            break
          }
        }

        if (stop) {
          break
        }
      }
     
      this.ready = true
    },
  },
};
</script>
<style lang="scss" scoped>
.c-the-plan {
  &-block {
    overflow: hidden;
    transition: width 0.3s;
    width: 5rem;
    // height: 3rem;

    &.shown {
      width: 17rem;
    }

    &-content {
      width: 14rem;
    }
  }
}
</style>